import React from 'react'
import ProgressBar from "../Components/ProgressBar"

const Progress = (props) => {
  return (
    <div>Progress
        <ProgressBar/>
    </div>
  )
}

export default Progress